import { useCallback, useState } from 'react';
import { REACT_APP_URL_RESET_PASSWORD } from '../../components/common/Routes/URLs';
import TempEdgeApi from '../../services/TempEdgeApi';

const useResetPassword = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const submit = useCallback(async ({ username, email, recaptchaToken }) => {
    setLoading(true);
    setResult(null);

    const payload = {
      email: email.toUpperCase(),
      username,
      hostname: window.location.origin,
      recaptchaToken
    };

    try {
      const data = await TempEdgeApi.publicPost({ url: REACT_APP_URL_RESET_PASSWORD, payload });
      setResult(data);
      return data;
    } catch (error) {
      setResult(error);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  return { submit, loading, result };
};

export default useResetPassword;
